// AUTO-GENERATED by vite-plugin-legacy-per-domain — do not edit
// Generated for publishing_domain="www" variant="snippet"

import "#/legacy/jquery-global.js";
import "../../../../../../app/frontend/src/shared/api/api-host-global.js";
import "#/legacy/globals.js";
import "#legacy/layouts/snippet.js";
import "../../../../../assets/javascripts/application.js";
import "#page_builder/components/behavior.js";
import "virtual:component-behaviors/www";

// Statically bundled: legacy code and inline scripts call window.DoctorFinder and
// window.AppointmentBooking.* directly.
//
// _namespaces.js MUST come before index.js — see comment in that file.
import "../../../../../../lib/sparkle/doctor_finder_v3/app/assets/javascripts/physician_finder/_namespaces.js";
import "../../../../../../lib/sparkle/doctor_finder_v3/app/assets/javascripts/physician_finder/index.js";
import "../../../../../../app/assets/javascripts/appointment_booking/related_providers_widget/index.js";
import "../../../../../../app/assets/javascripts/appointment_booking/slot_picker_modal/index.js";
import "../../../../../../app/assets/javascripts/appointment_booking/provider_widget/index.js";
// The stylesheets of these widgets, and of the mobile CTA below, are linked by the layout
// (`legacy_bundle_stylesheet_tags`), which picks the page's themed build.
// Physician profile page dependencies, called by inline scripts in physicians/show views.
import "../../../../../../app/assets/javascripts/controllers/physicians/show/profile_map.js";
import "../../../../../../app/assets/javascripts/physicians/comments.js";
// Slick carousel jQuery plugin, used by shared/components/slider.js for the page builder
// resource_collection slideshow variants.
import "../../../../../../vendor/assets/javascripts/slick.js";
// Slick's paired stylesheet (base `.slick-list { overflow: hidden }` clips
// off-screen slides) plus the sparkle theme overrides; the JS alone leaves
// `.slick-list` overflow visible, widening the page on mobile carousels.
import "../../../../../../lib/assets/stylesheets/slick/slick-theme-overrides-sparkle.scss";
// Mobile CTA modals/teasers, referenced by inline scripts on physician profile and landing pages.
import "../../../../../../app/assets/javascripts/application/mobile_cta/mobile_cta.js";
// Appointment booking wizard.
// _namespaces.js MUST come before index.js — it bootstraps the Wizard
// class and its static namespace properties (Views, Models, Collections,
// Events, Errors) so that sub-modules can reference them at initClass time.
import "../../../../../../app/assets/javascripts/appointment_booking/wizard/_namespaces.js";
import "../../../../../../app/assets/javascripts/appointment_booking/wizard/index.js";
// Slot suggester — same namespace-bootstrap pattern as the wizard.
import "../../../../../../app/assets/javascripts/appointment_booking/slot_suggester/_namespaces.js";
import "../../../../../../app/assets/javascripts/appointment_booking/slot_suggester/index.js";
// Decision tree viewer — mounted by the booking wizard Welcome step via a
// 'decision-tree-viewer:mount' custom event; the entrypoint is bundled statically so
// its event listener is registered.
import "../../../../../../app/frontend/entrypoints/decision_tree_viewer.js";

// Address availability status badges (open/closed/hours) on location
// cards. _namespaces.js must come before index.js to bootstrap
// AddressAvailability.Status.Views.
import "../../../../../../app/assets/javascripts/application/components/address_availability/status/_namespaces.js";
import "../../../../../../app/assets/javascripts/application/components/address_availability/status/index.js";
import "../../../../../../app/assets/javascripts/application/components/address_availability/index.js";

// Locations index map + list view — `new Sparkle.Views.MapWithLocationList(...)`
// is called from an inline script in app/views/locations/_multiple_locations.html.erb.
// It must be imported explicitly (it pulls in google_map.js via its own import).
import "../../../../../../app/assets/javascripts/application/components/map_with_list.js";

// Location browser — `new Sparkle.LocationBrowser(...)` is called from
// app/assets/javascripts/location_browser.js on the locations index page.
import "../../../../../../app/assets/javascripts/location_browser/index.js";

// `Sparkle.Locations.showLocationBrowser()` is called from
// app/views/location_browser/index.html+none.erb.
import "../../../../../../app/assets/javascripts/locations/index.js";

// Signal that all legacy globals are ready. Inline scripts wrapped in
// Sparkle.ready() (via capture_helper#js_content) will now execute.
if (window.Sparkle?.flushReady) {
  window.Sparkle.flushReady();
}
